import React from "react";
import PropTypes from "prop-types";

import AlmigButton from "../grundelemente/AlmigButton";

const ApplyDismiss = props => (
	<div className="apply-dismiss-buttons">
		<AlmigButton i18n_key="Dismiss" disabled={!props.state.any_change}
			onClick={props.dismiss} />
		<AlmigButton i18n_key="Apply"
			disabled={!props.state.all_ok || !props.state.any_change}
			onClick={props.apply} />
	</div>
);

ApplyDismiss.propTypes = {
	state: PropTypes.object.isRequired,
	apply: PropTypes.func.isRequired,
	dismiss: PropTypes.func.isRequired
};

export default ApplyDismiss;
